import { routePaths } from 'components/Routes/data';
import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { KycInfo } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/KycInfo';
import { PersonalDetails } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/PersonalDetails';
import { ReviewDetails } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/ReviewDetails';
import { Box, Modal, ModalBody, Spinner } from '@razorpay/blade/components';
import {
  SidebarContentWrapper,
  MultiStepFormWrapper,
  MainContentWrapper,
} from 'components/EmployeeOnboarding/components/styles';
import { OnboardingSidebar } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/components/OnboardingSidebar';
import { BankAccountDetails } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/BankAccountDetails';
import { FormProvider } from 'forms';
import { useSavedContractorData } from './hooks/useSavedContractorData';
import { Wizard, WizardStep } from 'forms/Wizard';
import { WizardInfoProvider } from 'components/WizardViews/providers/WizardInfoProvider';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { routeToStepMap } from './constants';

export const ContractorSelfOnboarding = () => {
  const location = useLocation();

  const { isLoadingQuery, selfOnboardingFormInitialData } = useSavedContractorData();

  if (location.pathname === routePaths.employeeOnboarding.contractorSelfOnboarding.root) {
    return <Redirect to={routePaths.employeeOnboarding.contractorSelfOnboarding.kycDetails} />;
  }

  if (isLoadingQuery) {
    return (
      <Box display="flex" height="80vh" alignItems="center" justifyContent="center">
        <Spinner accessibilityLabel="Loading" />
      </Box>
    );
  }

  return (
    <Box>
      <Modal isOpen={true} onDismiss={() => {}} size="full">
        <ModalBody padding="spacing.0">
          <FormProvider initialState={selfOnboardingFormInitialData}>
            <WizardInfoProvider beginStep={1} initialStep={1} totalSteps={4}>
              <MultiStepFormWrapper>
                <SidebarContentWrapper>
                  <OnboardingSidebar />
                </SidebarContentWrapper>
                <MainContentWrapper>
                  <WizardPathToStepController routeStepMap={routeToStepMap} />
                  <Switch>
                    <Wizard>
                      <WizardStep step={1} component={KycInfo} />
                      <WizardStep step={2} component={BankAccountDetails} />
                      <WizardStep step={3} component={PersonalDetails} />
                      <WizardStep step={4} component={ReviewDetails} />
                    </Wizard>
                  </Switch>
                </MainContentWrapper>
              </MultiStepFormWrapper>
            </WizardInfoProvider>
          </FormProvider>
        </ModalBody>
      </Modal>
    </Box>
  );
};
